import Flickity from "flickity";

export default function Entries() {
  Alpine.data("entries", () => ({
    flkty: null,

    init() {
      this.$nextTick(() => {
        if (!Flickity.create.equalHeightResizeClass) {
          Flickity.create.equalHeightResizeClass = function () {
            this.element.classList.add("flickity-resize");
          };

          const resize = Flickity.prototype.resize;
          Flickity.prototype.resize = function () {
            this.element.classList.remove("flickity-resize");
            resize.call(this);
            this.element.classList.add("flickity-resize");
          };
        }

        this.flkty = new Flickity(this.$refs.slider, {
          cellAlign: "left",
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          contain: false,
        });

        this.flkty.on("dragStart", () =>
          this.flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "none"),
          ),
        );
        this.flkty.on("dragEnd", () =>
          this.flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "all"),
          ),
        );
        const observer = new IntersectionObserver(
          (entries, obs) => {
            if (!entries[0].isIntersecting) return;
            obs.disconnect();

            // if (!Flickity.create.equalHeightResizeClass) {
            //   Flickity.create.equalHeightResizeClass = function () {
            //     this.element.classList.add("flickity-resize");
            //   };

            //   const resize = Flickity.prototype.resize;
            //   Flickity.prototype.resize = function () {
            //     this.element.classList.remove("flickity-resize");
            //     resize.call(this);
            //     this.element.classList.add("flickity-resize");
            //   };
            // }

            // this.flkty = new Flickity(this.$refs.slider, {
            //   cellAlign: "left",
            //   wrapAround: true,
            //   prevNextButtons: false,
            //   pageDots: false,
            //   draggable: true,
            //   contain: false,
            // });

            // this.flkty.on("dragStart", () =>
            //   this.flkty.slider.childNodes.forEach(
            //     (slide) => (slide.style.pointerEvents = "none"),
            //   ),
            // );
            // this.flkty.on("dragEnd", () =>
            //   this.flkty.slider.childNodes.forEach(
            //     (slide) => (slide.style.pointerEvents = "all"),
            //   ),
            // );
          },
          { rootMargin: "1000px" },
        );

        observer.observe(this.$refs.slider);
      });
    },
    prev() {
      this.flkty.previous();
    },
    next() {
      this.flkty.next();
    },
    destroy() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
    },
  }));
}
